import { render, staticRenderFns } from "./PayrollDetailGrid.vue?vue&type=template&id=764f1ae6&scoped=true&"
import script from "./PayrollDetailGrid.vue?vue&type=script&lang=ts&"
export * from "./PayrollDetailGrid.vue?vue&type=script&lang=ts&"
import style0 from "./PayrollDetailGrid.vue?vue&type=style&index=0&id=764f1ae6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f1ae6",
  null
  
)

export default component.exports